//Lovingly stolen from -https://stackoverflow.com/questions/12931828/convert-returned-json-object-properties-to-lower-first-camelcase
export var toCamel = function toCamel(o) {
  var newO, origKey, newKey, value;

  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === "object") {
        value = toCamel(value);
      }

      return value;
    });
  } else {
    newO = {};

    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        var _value;

        newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
        value = o[origKey];

        if (value instanceof Array || value !== null && ((_value = value) === null || _value === void 0 ? void 0 : _value.constructor) === Object) {
          value = toCamel(value);
        }

        newO[newKey] = value;
      }
    }
  }

  return newO;
};
export var toPascal = function toPascal(o) {
  var newO, origKey, newKey, value;

  if (o instanceof Array) {
    return o.map(function (value) {
      if (typeof value === "object") {
        value = toPascal(value);
      }

      return value;
    });
  } else {
    newO = {};

    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString();
        value = o[origKey];

        if (value instanceof Array || value !== null && value.constructor === Object) {
          value = toPascal(value);
        }

        newO[newKey] = value;
      }
    }
  }

  return newO;
};
export var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  try {
    return string.charAt(0).toUpperCase() + string.slice(1);
  } catch (_unused) {
    return string;
  }
};
export var capitalizeObjEntries = function capitalizeObjEntries(obj) {
  if (obj && Array.isArray(obj)) {
    return obj;
  }

  if (obj && typeof obj === "object") {
    var entries = Object.entries(obj);
    var capsEntries = entries.map(function (entry) {
      return [entry[0][0].toUpperCase() + entry[0].slice(1), entry[1] && typeof entry[1] === "object" ? capitalizeObjEntries(entry[1]) : entry[1]];
    });
    var capsObj = Object.fromEntries(capsEntries);
    return capsObj;
  } else {
    return obj;
  }
};